<template>
  <Layout v-if="shouldUseLayout">
    <router-view />
  </Layout>
  <router-view v-else />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Layout from '@/components/Layout.vue'

const route = useRoute()
const shouldUseLayout = computed(() => route.meta.layout !== 'blank')
</script>

<style lang="less">
// 全局样式已在 main.ts 中导入，这里不需要重复定义
</style>
